import { isPlayerLocked } from '../../../logic/lock/lock.utils';
import { EXIT_APP_SIGNAL, HIDE_POPUP_SIGNAL, ROUTE_BACK_SIGNAL } from '../../popupContainer/popupContainer.constants';
import { SubscriptionExpired } from '../../subscriptionExpired/subscriptionExpired.component';
import { Upsell } from '../../subscriptionExpired/new/upsell/upsell.component';
import { AbstractPopup } from '../abstractPopup/abstractPopup.component';
import { getUpsell } from './subscriptionPopup.utils';
import connect from './subscriptionPopup.connector';

export class SubscriptionPopup extends AbstractPopup {
  static _template() {
    return {
      Regular: {
        type: SubscriptionExpired,
        passSignals: {
          [HIDE_POPUP_SIGNAL]: true,
          [ROUTE_BACK_SIGNAL]: true,
        },
      },
      Upsell: {
        type: Upsell,
        passSignals: {
          [HIDE_POPUP_SIGNAL]: true,
          [ROUTE_BACK_SIGNAL]: true,
        },
      },
      passSignals: {
        [HIDE_POPUP_SIGNAL]: true,
        [ROUTE_BACK_SIGNAL]: true,
        [EXIT_APP_SIGNAL]: true,
      },
    };
  }

  _active() {
    this._unsubscribe = connect(this);
  }

  _inactive() {
    if (this._unsubscribe) {
      this._unsubscribe();
      this._unsubscribe = null;
    }
  }

  set entityType(value) {
    this.routeBackOnClose = this.routeBackOnClose || isPlayerLocked(value);
  }

  set payload(value) {
    this.tag('Regular').payload = value;
    this.tag('Upsell').payload = value;
  }

  set lock(value) {
    const upsell = getUpsell(value);

    this.tag('Regular').visible = !upsell;
    this.tag('Upsell').visible = !!upsell;
    const tag = upsell ? 'Upsell' : 'Regular';

    this.tag(tag).requiredFeatures = upsell.details ? upsell.details.products : [];
    this.tag(tag).lock = value;
  }

  _getFocused() {
    const regular = this.tag('Regular');
    const upsell = this.tag('Upsell');

    if (regular.visible) {
      return regular;
    }

    if (upsell.visible) {
      return upsell;
    }

    return undefined;
  }
}
